var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { observer } from '@formily/reactive-vue';
import { connect, mapProps, mapReadPretty, h } from '@formily/vue';
import { ref, defineComponent } from '@vue/composition-api';
import { Cascader as VanCascader } from 'vant';
import { Popup as VanPopup } from 'vant';
import FormItem from '../form-item';
import { PreviewText } from '../preview-text';
var BaseCascader = observer(defineComponent({
    name: 'FBaseCascader',
    setup: function (props, _a) {
        var attrs = _a.attrs, emit = _a.emit, slots = _a.slots;
        var _b = attrs, _c = _b.formItemProps, formItemProps = _c === void 0 ? {} : _c, _d = _b.popupProps, popupProps = _d === void 0 ? {} : _d, _e = _b.cascaderProps, cascaderProps = _e === void 0 ? {} : _e, _f = _b.fieldListeners, fieldListeners = _f === void 0 ? {} : _f, _g = _b.popupListeners, popupListeners = _g === void 0 ? {} : _g, _h = _b.cascaderListeners, cascaderListeners = _h === void 0 ? {} : _h;
        var format = formItemProps.format;
        var show = ref(false);
        return function () {
            return h('div', {}, {
                default: function () { return [
                    h(FormItem, {
                        attrs: __assign({ value: format ? format(attrs.value) : attrs.value, readonly: true, clickable: true }, formItemProps),
                        on: __assign({ click: function () {
                                show.value = true;
                            } }, fieldListeners),
                    }, slots),
                    h(VanPopup, {
                        attrs: __assign({ value: show.value, round: true, position: 'bottom' }, popupProps),
                        on: __assign({ input: function (val) {
                                show.value = val;
                            } }, popupListeners),
                    }, {
                        default: function () { return [
                            h(VanCascader, {
                                attrs: __assign({}, cascaderProps),
                                on: __assign({ close: function () {
                                        show.value = false;
                                    }, finish: function (val) {
                                        emit('change', val);
                                        show.value = false;
                                    } }, cascaderListeners),
                            }, {}),
                        ]; },
                    }),
                ]; },
            });
        };
    },
}));
export var Cascader = connect(BaseCascader, mapProps({ readOnly: 'readonly' }), mapReadPretty(PreviewText.Cascader));
export default Cascader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/cascader/index.js
// module id = null
// module chunks = 